import type {SectionHeroProps} from './components/SectionHero/SectionHero'
import SectionTemplate from './components/SectionTemplate/SectionTemplate'

const COPY = {
  intro: {
    title: 'Work together, achieve more',
    description:
      'Collaborate with your teams, use project management tools that sync with your projects, and code from anywhere, all on a single, integrated platform.',
  },
  hero: {
    aria: {
      // TODO: Update once known
      autoPlayButton: {
        play: 'Play',
        pause: 'Pause',
      },
    },
  },
  content: {
    title: 'Your workflows, your way.',
    description: ' Plan effectively with an adaptable spreadsheet that syncs with your work.',
    link: {
      url: '/features/issues',
      label: 'Jump into GitHub Projects',
    },
  },
  testimonial: {
    quote:
      'It helps us onboard new software engineers and get them productive right away. We have all our source code, issues, and pull requests in one place. ... GitHub is a complete platform that frees us from menial tasks and enables us to do our best work.',
    name: 'Fabian Faulhaber',
    position: 'Application Manager at Mercedes-Benz',
  },
  accordion: [
    {
      title: 'Keep track of your tasks',
      description: 'Create issues and manage projects with tools that adapt to your code.',
      link: {
        label: 'Explore GitHub Issues',
        url: '/features/issues',
      },
      visual: {
        url: '/images/modules/site/home24/collaboration/accordion-1.webp',
        // TODO: Update once known
        alt: '',
      },
    },
    {
      title: 'Share ideas and ask questions',
      description: 'Create space for open-ended conversations alongside your project.',
      link: {
        label: 'Discover GitHub Discussions',
        url: '/features/discussions',
      },
      visual: {
        url: '/images/modules/site/home24/collaboration/accordion-2.webp',
        // TODO: Update once known
        alt: '',
      },
    },
    {
      title: 'Review code changes together',
      description: 'Create review processes that improve code quality and fit neatly into your workflow.',
      link: {
        label: 'Learn about code review',
        url: '/features/code-review',
      },
      visual: {
        url: '/images/modules/site/home24/collaboration/accordion-3.webp',
        // TODO: Update once known
        alt: '',
      },
    },
    {
      title: 'Fund open source projects',
      description: 'Become an open source partner and support the tools and libraries that power your work.',
      link: {
        label: 'Dive into GitHub Sponsors',
        url: '/sponsors',
      },
      visual: {
        url: '/images/modules/site/home24/collaboration/accordion-4.webp',
        // TODO: Update once known
        alt: '',
      },
    },
  ],
}

// TODO: Update once known
const HERO_VISUALS: SectionHeroProps['visuals'] = [
  {
    url: '/images/modules/site/home24/collaboration/hero.webp',
    alt: '',
  },
]

export default function Collaboration() {
  return (
    <section id="collaboration" className="lp-Section">
      <SectionTemplate
        intro={{
          mascot: 'mona',
          title: COPY.intro.title,
          description: COPY.intro.description,
        }}
        hero={{visuals: HERO_VISUALS, autoPlayButtonAriaLabel: COPY.hero.aria.autoPlayButton}}
        content={COPY.content}
        testimonial={COPY.testimonial}
        accordion={COPY.accordion}
      />
    </section>
  )
}

try{ Collaboration.displayName ||= 'Collaboration' } catch {}